import axios from "axios";

const http = axios.create({
	baseURL: import.meta.env.VUE_APP_API_BASE_URL + "api/partners",
});

export function setAuthToken(token) {
	if (token) {
		http.defaults.headers.common.Authorization = "Bearer " + token;
	} else {
		delete http.defaults.headers.common.Authorization;
	}
}

export default http;
